import { render } from "./ConnectBtn.vue?vue&type=template&id=c6a9e2dc&ts=true"
import script from "./ConnectBtn.vue?vue&type=script&lang=ts"
export * from "./ConnectBtn.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__